import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';
import { useNotifications } from '../services/NotificationContext';
import '../styles/Navbar.css';

function Navbar() {
  const location = useLocation();
  const { profile, user } = useAuth();
  const { pendingRequests, unreadMessages } = useNotifications();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  const displayName = profile?.full_name || user?.user_metadata?.full_name || '';
  const initial = displayName.charAt(0).toUpperCase() || 'U';

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-accent">ppl</span>YouKnow
        </Link>

        <div className="navbar-menu">
          <Link to="/" className={`navbar-item ${isActive('/')}`}>Feed</Link>
          <Link to="/friends" className={`navbar-item ${isActive('/friends')} nav-item-wrap`}>
            Friends
            {pendingRequests > 0 && <span className="nav-badge">{pendingRequests}</span>}
          </Link>
          <Link to="/messages" className={`navbar-item ${location.pathname.startsWith('/messages') ? 'active' : ''} nav-item-wrap`}>
            Messages
            {unreadMessages > 0 && <span className="nav-badge">{unreadMessages}</span>}
          </Link>
          <Link to="/profile" className={`navbar-item ${isActive('/profile')} navbar-profile-link`}>
            {profile?.avatar_url
              ? <img src={profile.avatar_url} alt={displayName} className="navbar-avatar" />
              : <span className="navbar-avatar navbar-avatar-initial">{initial}</span>
            }
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
